module.exports = __webpack_public_path__ + "static/media/face.f4f3dd7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/face.png
// module id = 135
// module chunks = 0